/* ============================================================
   Asha Books — Order Tracker
   File: assets/order-tracker.js
   ============================================================ */

(function () {
  'use strict';

  const API_URL = window.orderTrackerConfig?.apiUrl || '';

  const form       = document.getElementById('ot-form');
  const orderInput = document.getElementById('ot-input-order');
  const phoneInput = document.getElementById('ot-input-phone');
  const submitBtn  = document.getElementById('ot-submit');
  const spinner    = document.getElementById('ot-spinner');
  const errorEl    = document.getElementById('ot-error');
  const resultEl   = document.getElementById('ot-result');
  const resultOrder  = document.getElementById('ot-result-order');
  const resultBadge  = document.getElementById('ot-result-badge');
  const resultBody   = document.getElementById('ot-result-body');

  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const order = orderInput.value.trim();
    const phone = phoneInput.value.trim();

    if (!order || !phone) {
      showError('Please fill in both your order number and phone number.');
      return;
    }

    // Reset UI
    hide(errorEl);
    hide(resultEl);
    show(spinner);
    submitBtn.disabled = true;
    submitBtn.textContent = 'Looking up…';

    try {
      const url = `${API_URL}/.netlify/functions/get-tracking` +
        `?order=${encodeURIComponent(order)}&phone=${encodeURIComponent(phone)}`;

      const res  = await fetch(url);
      const data = await res.json();

      hide(spinner);
      submitBtn.disabled = false;
      submitBtn.textContent = 'Track';

      if (!res.ok) {
        showError(data.error || 'Something went wrong. Please try again.');
        return;
      }

      renderResult(data);

    } catch (err) {
      hide(spinner);
      submitBtn.disabled = false;
      submitBtn.textContent = 'Track';
      showError('Could not connect. Please check your internet connection and try again.');
    }
  });

  // Maps Shopify's tracking_company string (case-insensitive) to a tracking URL and display name.
  // Returns null if the courier isn't recognised.
  function getCourierInfo(trackingCompany) {
    if (!trackingCompany) return null;
    const name = trackingCompany.toLowerCase();
    if (name.includes('stc'))     return { label: 'STC Courier',  url: 'https://stcourier.com/track/shipment' };
    if (name.includes('dtdc'))    return { label: 'DTDC',          url: 'https://www.dtdc.com/track-your-shipment/' };
    if (name.includes('trackon')) return { label: 'Trackon',       url: 'https://www.trackon.in/' };
    return null;
  }

  function renderResult(data) {
    resultOrder.textContent = data.order;

    if (data.status === 'not_shipped') {
      resultBadge.textContent = 'Not yet shipped';
      resultBadge.className = 'ot__result-badge ot__result-badge--pending';
      resultBody.innerHTML = `<p class="ot__pending-msg">${escHtml(data.message)}</p>`;
    } else {
      resultBadge.textContent = 'Shipped';
      resultBadge.className = 'ot__result-badge ot__result-badge--shipped';

      if (data.trackingNumber) {
        const courier = getCourierInfo(data.trackingCompany);
        const trackUrl = data.trackingUrl || (courier ? courier.url : null);
        const trackLabel = courier ? courier.label : (data.trackingCompany || 'Courier');
        const trackLink = trackUrl
          ? `<a class="ot__track-btn"
               href="${escHtml(trackUrl)}"
               target="_blank"
               rel="noopener noreferrer">
              ${courier ? `Track with ${escHtml(trackLabel)}` : 'Track your shipment'} →
             </a>`
          : '';

        resultBody.innerHTML = `
          <p class="ot__tracking-label">Tracking number</p>
          <p class="ot__tracking-number" id="ot-tracking-num">${escHtml(data.trackingNumber)}</p>
          <div class="ot__actions">
            <button class="ot__copy-btn" id="ot-copy-btn">Copy number</button>
            ${trackLink}
          </div>
        `;

        document.getElementById('ot-copy-btn').addEventListener('click', () => {
          copyToClipboard(data.trackingNumber);
        });
      } else {
        resultBody.innerHTML = `<p class="ot__pending-msg">Your order has been shipped but a tracking number is not yet available. Please check back soon.</p>`;
      }
    }

    show(resultEl);
  }

  function copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(() => {
      const btn = document.getElementById('ot-copy-btn');
      if (!btn) return;
      btn.textContent = 'Copied!';
      btn.classList.add('ot__copy-btn--copied');
      setTimeout(() => {
        btn.textContent = 'Copy number';
        btn.classList.remove('ot__copy-btn--copied');
      }, 2500);
    }).catch(() => {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    });
  }

  function showError(msg) {
    errorEl.textContent = msg;
    show(errorEl);
  }

  function show(el) { el.style.display = 'block'; }
  function hide(el) { el.style.display = 'none'; }

  function escHtml(str) {
    return str.replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));
  }

})();
